import { forwardRef, ForwardedRef, useEffect, useImperativeHandle, useRef } from 'react';

import { StyledTextArea } from './InlineEdit.styled';
import { EDIT_INPUT_TEST_ID } from './constants';
import type { InlineEditProps } from './types';

export const InlineEditAreaInput = forwardRef(
  (
    {
      autoFocus = true,
      hasError,
      id = 'uiInlineEditArea',
      isRequired = false,
      maxLength,
      onBlur,
      onChange,
      placeholder = '',
      showFocused = false,
      value = '',
    }: InlineEditProps,
    ref: ForwardedRef<HTMLTextAreaElement>,
  ) => {
    const textAreaRef = useRef<HTMLTextAreaElement>(null);

    // combine the references
    useImperativeHandle(ref, () => textAreaRef.current as HTMLTextAreaElement);

    useEffect(() => {
      if (textAreaRef.current) {
        textAreaRef.current.style.height = 'auto';
        textAreaRef.current.style.height = textAreaRef.current.scrollHeight + 'px';
      }
    }, [value]);

    return (
      <StyledTextArea
        autoFocus={autoFocus}
        data-test={EDIT_INPUT_TEST_ID}
        hasError={hasError}
        id={id}
        isRequired={isRequired}
        maxLength={maxLength}
        onBlur={onBlur}
        onChange={onChange}
        placeholder={placeholder}
        ref={textAreaRef}
        rows={1}
        showFocused={showFocused}
        value={value}
      />
    );
  },
);
